"use client";

import { useEffect, useState } from "react";
import { useMediaQuery } from "react-responsive";
import { getCurrentDomain } from "@/lib/domainConfig";
import { VideoAd } from "@/components/Ads/AdComponent";
import { ProsperInContentVideo } from "@/components/Ads/ProsperPlacements";

interface DomainVideoAdProps {
  screen: "desktop" | "mobile";
  alias?: string;
}

export default function DomainVideoAd({ screen, alias }: DomainVideoAdProps) {
  const [domain, setDomain] = useState<"gumgum" | "tcgfan" | "default">(
    "default",
  );
  const isDesktopOrLaptop = useMediaQuery({
    query: "(min-width: 1250px)",
  });

  useEffect(() => {
    const currentDomain = getCurrentDomain(window.location.host);
    setDomain(currentDomain);
  }, []);

  const isDesktop = isDesktopOrLaptop;
  const isMobileView = !isDesktopOrLaptop;

  // Only show the ad if the screen matches the current viewport
  const shouldShow =
    (screen === "desktop" && isDesktop) ||
    (screen === "mobile" && isMobileView);

  if (!shouldShow) {
    return null;
  }

  // For gumgum.gg, use existing VideoAd
  if (domain === "gumgum") {
    return <VideoAd screen={screen} />;
  }

  // For tcgfan.com, use Prosper video ad
  if (domain === "tcgfan") {
    return (
      <ProsperInContentVideo
        alias={alias || `video-${screen}`}
        className="min-h-[250px] md:min-h-[360px]"
      />
    );
  }

  // Default behavior for localhost/other domains - show existing ads
  return <VideoAd screen={screen} />;
}
